module.exports = __webpack_public_path__ + "static/img/bigWheelTop.86dbe55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bigWheelTop.png
// module id = tOAc
// module chunks = 2